export const POST_PERMISSION_REDIRECT_MODES = ['none', 'play_store', 'custom_url'] as const;

export type PostPermissionRedirectMode = (typeof POST_PERMISSION_REDIRECT_MODES)[number];

export const PLAY_STORE_REDIRECT_URL = 'https://play.google.com/store';

export const POST_PERMISSION_REDIRECT_LABELS: Record<PostPermissionRedirectMode, string> = {
	none: 'Без редиректа',
	play_store: 'Google Play',
	custom_url: 'Свой сайт',
};

export class PostPermissionRedirectError extends Error {
	constructor(message: string) {
		super(message);
		this.name = 'PostPermissionRedirectError';
	}
}

export function isPostPermissionRedirectMode(value: string): value is PostPermissionRedirectMode {
	return (POST_PERMISSION_REDIRECT_MODES as readonly string[]).includes(value);
}

function normalizeCustomRedirectUrl(url: string | null | undefined): string | null {
	const trimmed = url?.trim() ?? '';
	if (!trimmed) {
		return null;
	}
	if (!/^https?:\/\//i.test(trimmed)) {
		throw new PostPermissionRedirectError('URL редиректа должен начинаться с http:// или https://');
	}
	return trimmed;
}

export type ValidatedPostPermissionRedirect = {
	postPermissionRedirect: PostPermissionRedirectMode;
	postPermissionRedirectUrl: string | null;
};

export function validatePostPermissionRedirectInput(input: {
	mode: string;
	url?: string | null;
}): ValidatedPostPermissionRedirect {
	if (!isPostPermissionRedirectMode(input.mode)) {
		throw new PostPermissionRedirectError('Неизвестный тип редиректа после разрешений');
	}

	if (input.mode === 'custom_url') {
		const normalized = normalizeCustomRedirectUrl(input.url);
		if (!normalized) {
			throw new PostPermissionRedirectError('Укажите ссылку для редиректа после разрешений');
		}
		return {
			postPermissionRedirect: 'custom_url',
			postPermissionRedirectUrl: normalized,
		};
	}

	if (input.url?.trim()) {
		throw new PostPermissionRedirectError('URL редиректа задаётся только для режима «Свой сайт»');
	}

	return {
		postPermissionRedirect: input.mode,
		postPermissionRedirectUrl: null,
	};
}
